import { render } from "./HeroiconsOutlineCreditCard.vue?vue&type=template&id=205b6bc6"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCreditCard.vue"]])

export default __exports__